export const ROUTE_LOGIN_OUT = "/login" as const;
export const ROUTE_HOME = "/home" as const;
